export const enum SnRefreshState {
  None = 'none',
  Updating = 'updating',
  Pulling = 'pulling',
}

export function calculateMovement(movement: number, threshold: number): number {
  return threshold * log10((movement + threshold) / threshold) * 2;
}

function log10(x: number): number {
  return Math.log(x) / Math.LN10;
}
